import _ from 'lodash'
import favoritesApi from '@/services/api/favorites'
import { VRLOUNGE, COMPANY } from '@/api/constants'

const dataStructure = {
  users: [],
  markers: [],
  nameCards: []
}

const state = {
  inited: false,
  data: {},
  acceptedCategories: [
    'user', // Company
    'panorama',
    'marker',
    'nameCard'
  ],
  acceptedMarkerTypes: [
    'tag',
    'gallery',
    'multitag',
    'videoplay',
    'popup',
    'arMakerTag',
    'memo',
    'pdf'
  ],
  dialog: {
    visible: false
  }
}

const getters = {
  enabled: (state, getters, rootState) => {
    if (rootState.buildings.currentBuilding.myFavoriteEnable || rootState.property.property.myFavoriteEnable) return true
    if (VRLOUNGE.GROUPS.includes(rootState.property.property.objectId)) return true // 兼容 WEA
    if (rootState.user.user.headquarter.title === COMPANY.WEA) return true // 兼容 WEA
    return false
  }
}

const actions = {
  async init ({ commit, rootState }) {
    const data = await favoritesApi.get()
    commit('INITED', data || dataStructure)
    return Promise.resolve()
  },
  destroy ({ commit }) {
    commit('DESTROY')
  },
  async add ({ state, dispatch, commit }, { category, id } = {}) {
    if (!state.acceptedCategories.includes(category)) {
      return Promise.resolve()
    }

    dispatch('updatePlaceHolder', {
      type: 'add',
      category,
      id
    })

    const response = await favoritesApi.create({
      identifier: category,
      identifierId: id
    })
    commit('UPDATE', response)
  },
  async remove ({ state, dispatch, commit }, { category, id } = {}) {
    if (!state.acceptedCategories.includes(category)) {
      return Promise.resolve()
    }

    dispatch('updatePlaceHolder', {
      type: 'remove',
      category,
      id
    })

    const response = await favoritesApi.remove({
      identifier: category,
      identifierId: id
    })
    commit('UPDATE', response)
  },
  async update ({ state, commit }, { favoriteId, payload = {} } = {}) {
    // favoriteId = unique id for favorite item
    const response = await favoritesApi.update({
      favoriteId,
      payload
    })
    commit('UPDATE', response)
  },
  updatePlaceHolder ({ commit, rootGetters }, { type, category, id }) {
    const updateHandler = ({ category, callback }) => {
      const isPano = category === 'panorama'
      const realCategory = isPano
        ? 'user'
        : category
      const categoryDataKey = realCategory + 's'
      const data = _.cloneDeep(state.data)

      let categoryData
      if (isPano) {
        categoryData = data[categoryDataKey] || []

        const userId = rootGetters.user.objectId
        const index = categoryData.findIndex(data => data.id === userId)
        const userData = index > -1
          ? categoryData[index]
          : {
              id: userId,
              panoramas: []
            }
        userData.panoramas = callback(userData.panoramas || [])
        if (index > -1) {
          categoryData[index] = userData
        } else {
          categoryData.push(userData)
        }
      } else {
        categoryData = callback(data[categoryDataKey] || [])
      }

      const payload = {
        ...data,
        [categoryDataKey]: categoryData
      }
      return payload
    }

    let tempData = {}
    if (type === 'add') {
      tempData = updateHandler({
        category,
        callback (data) {
          data.push({
            id
          })
          return data
        }
      })
    } else if (type === 'remove') {
      tempData = updateHandler({
        category,
        callback (data) {
          const index = data.findIndex(item => item.id === id)
          if (index > -1) {
            data.splice(index, 1)
          }
          return data
        }
      })
    }
    commit('UPDATE', tempData)
  },
  showDialog ({ commit }, value = true) {
    commit('SHOW_DIALOG', value)
  }
}

const mutations = {
  INITED (state, data) {
    state.data = data
    state.inited = true
  },
  DESTROY (state) {
    state.data = dataStructure
    state.inited = false
  },
  UPDATE (state, data) {
    state.data = data || dataStructure
  },
  SHOW_DIALOG (state, value) {
    state.dialog.visible = value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
